import { MarketingPreferencesFormValue } from '@checkout/util-models';
import {
  CustomerDetails,
  CustomerMarketingPreferenceDetails,
} from '@domgen/dgx-fe-common';

export function formatCustomerDetailsToMarketingPreferencesFormValue(
  personDetails?: CustomerDetails
): MarketingPreferencesFormValue | undefined {
  if (!personDetails?.marketingPreferences) {
    return undefined;
  }

  return {
    marketingPreferenceEmail: personDetails.marketingPreferences.email,
    marketingPreferencePost: personDetails.marketingPreferences.post,
    marketingPreferenceTelephone: personDetails.marketingPreferences.telephone,
  };
}

export function formatMarketingPreferenceDetails(
  formValue: MarketingPreferencesFormValue
): CustomerMarketingPreferenceDetails {
  return {
    email: Boolean(formValue.marketingPreferenceEmail),
    post: Boolean(formValue.marketingPreferencePost),
    telephone: Boolean(formValue.marketingPreferenceTelephone),
  };
}
